(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5244],{

/***/ 85883:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogue",
      function () {
        return __webpack_require__(99592);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _meta_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53183);



var PageMetaHead = function(param) {
    var page_meta = param.page_meta, useExactTitle = param.useExactTitle;
    if (!page_meta) return null;
    var title = page_meta.title ? "".concat(_meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC, " - ").concat(page_meta.title) : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    if (useExactTitle) {
        title = page_meta.title ? page_meta.title : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            page_meta.keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_META_KEYWORDS */ .FK
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: title
            }, "og:site_name"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }, "twitter:title"),
            page_meta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: page_meta.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: page_meta.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: page_meta.description
                    }, "twitter:description")
                ]
            }),
            page_meta.thumbnail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: page_meta.thumbnail
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: page_meta.thumbnail
                    }, "og:image:secure_url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: page_meta.thumbnail
                    }, "twitter:image")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaHead);


/***/ }),

/***/ 35423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useStickyState = function(elementRef) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSticky = ref[0], setIsSticky = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getTopOffset = function() {
            if (elementRef.current) {
                var computedStyle = window.getComputedStyle(elementRef.current);
                var topValue = computedStyle.top || "0px";
                return parseFloat(topValue); // Convert '1rem' or other units to a number
            }
            return 0;
        };
        var checkSticky = function() {
            if (elementRef.current) {
                var rect = elementRef.current.getBoundingClientRect();
                var topOffset = getTopOffset();
                var isNowSticky = rect.top <= topOffset && rect.bottom > topOffset;
                setIsSticky(isNowSticky);
            }
        };
        window.addEventListener("scroll", checkSticky);
        checkSticky(); // Initial check
        return function() {
            return window.removeEventListener("scroll", checkSticky);
        };
    }, [
        elementRef
    ]);
    return isSticky;
};
/* harmony default export */ __webpack_exports__["Z"] = (useStickyState);


/***/ }),

/***/ 99592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36123);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81023);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_logic_config_meta_PageMetaHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51199);
/* harmony import */ var src_logic_hooks_use_header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85736);
/* harmony import */ var src_logic_hooks_use_sticky_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35423);
/* harmony import */ var src_ui_components_dumb_procurement_product_form_manager_general_components_form_with_summary_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9146);
/* harmony import */ var src_ui_components_smart_catalogue_advanced_filters_AdvancedFiltersResults__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(490);
/* harmony import */ var src_ui_components_smart_catalogue_catalogue_content_CatalogueContent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30376);











var CatalogueIndexPage = function() {
    (0,src_logic_hooks_use_header__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("Directory", null);
    var stickyRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef(null);
    var isSticky = (0,src_logic_hooks_use_sticky_state__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(stickyRef);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
        sx: {
            bgcolor: "background.primary.main",
            width: "100%",
            minHeight: "calc(100vh - 66px)"
        },
        container: true,
        component: _styles__WEBPACK_IMPORTED_MODULE_2__/* .ResponsiveContainer */ .h,
        gap: 2,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
            container: true,
            pb: 5,
            mt: 3,
            sx: {
                maxWidth: "1400px",
                marginInline: "auto",
                position: "relative",
                flexDirection: "column"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        width: "100%",
                        top: "0",
                        position: "sticky",
                        zIndex: 2
                    },
                    ref: stickyRef,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: "100%",
                            boxShadow: isSticky ? "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" : "14px 17px 40px 4px #7090B014",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            maxHeight: "95vh",
                            overflow: "auto"
                        },
                        className: "styled-scrollbar",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_ui_components_smart_catalogue_catalogue_content_CatalogueContent__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            closeOnClickOutside: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        paddingTop: "1rem",
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_ui_components_smart_catalogue_advanced_filters_AdvancedFiltersResults__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                })
            ]
        })
    });
};
CatalogueIndexPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .MainLayout */ .ZnA, {
        showAddNewPrivateItemLink: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_logic_config_meta_PageMetaHead__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                page_meta: {
                    title: "AI-Powered Procurement Catalog | Smart Automation for Sourcing",
                    description: "Integrate supplier data with AI-powered procurement catalogs. Use smart search, real-time analytics, and catalog automation to simplify sourcing and speed up RFQs.",
                    keywords: "AI procurement catalogue, intelligent catalog management, AI product catalog automation, smart procurement catalog, AI supplier catalog integration, automated RFQ catalog, real\u2011time catalog analytics, AI\u2011powered catalog search, machine learning catalog optimization, procurement catalog digital transformation"
                },
                useExactTitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_ui_components_dumb_procurement_product_form_manager_general_components_form_with_summary_layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: page
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CatalogueIndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5079,7311,1498,376,5676,983,490,9774,2888,179], function() { return __webpack_exec__(85883); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);